import apiService from './apiService';

const PREFIX = '/kkp/sommaire';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res;
}

const kkpSommaireService = {
  async list(params = {}) {
    const res = await request(apiService.get(PREFIX, params));
    return res.data;
  },

  async get(id) {
    const res = await request(apiService.get(`${PREFIX}/${id}`));
    return res.data?.sommaire;
  },

  async create(payload) {
    const res = await request(apiService.post(PREFIX, payload));
    return res.data?.sommaire;
  },

  async update(id, payload) {
    const res = await request(apiService.put(`${PREFIX}/${id}`, payload));
    return res.data?.sommaire;
  },

  async remove(id) {
    await request(apiService.delete(`${PREFIX}/${id}`));
  },

  async validateAndSend(id, payload) {
    const res = await request(apiService.post(`${PREFIX}/${id}/validate-send`, payload));
    return res.data;
  },

  async listCarnets() {
    const res = await request(apiService.get(`${PREFIX}/carnets`));
    return {
      carnets: res.data?.carnets ?? [],
      users: res.data?.users ?? [],
    };
  },

  async createCarnet(payload) {
    const res = await request(apiService.post(`${PREFIX}/carnets`, payload));
    return res.data?.carnet;
  },

  async updateCarnet(id, payload) {
    const res = await request(apiService.put(`${PREFIX}/carnets/${id}`, payload));
    return res.data?.carnet;
  },

  async removeCarnet(id) {
    await request(apiService.delete(`${PREFIX}/carnets/${id}`));
  },

  async createContact(payload) {
    const res = await request(apiService.post(`${PREFIX}/contacts`, payload));
    return res.data?.contact;
  },

  async updateContact(id, payload) {
    const res = await request(apiService.put(`${PREFIX}/contacts/${id}`, payload));
    return res.data?.contact;
  },

  async removeContact(id) {
    await request(apiService.delete(`${PREFIX}/contacts/${id}`));
  },
};

export default kkpSommaireService;
